export default __webpack_public_path__ + "static/media/benefit-icon.6371ff41.svg";